module.exports = __webpack_public_path__ + "static/media/walking10.af51052e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/walking10.jpg
// module id = 2031
// module chunks = 0